import React from "react";
import { View, Text, StyleSheet, FlatList, StatusBar } from "react-native";
import Colors from "../constants/Colors";
import GridTile from "../components/GridTile";
import GridTileTwo from "../components/GridTileTwo";
import GridTileThree from "../components/GridTileThree";
import { useSelector, useDispatch } from "react-redux";

const HomeScreen = (props) => {
  const popularNfts = useSelector((state) => state.nfts.popularNfts);
  const formatData = (data, numColumns) => {
    const numberOfFullRows = Math.floor(data.length / numColumns);

    let numberOfElementsLastRow = data.length - numberOfFullRows * numColumns;
    while (
      numberOfElementsLastRow !== numColumns &&
      numberOfElementsLastRow !== 0
    ) {
      data.push({ key: `blank-${numberOfElementsLastRow}`, empty: true });
      numberOfElementsLastRow++;
    }

    return data;
  };
  const numColumns = 2;
  const renderGridItem = (itemData) => {
    return (
      <GridTileTwo
        title={itemData.item.title}
        imageUrl={itemData.item.imageUrl}
        collectionImageUrl={itemData.item.collectionImageUrl}
        artist={itemData.item.artist}
        onSelect={() => {
          props.navigation.navigate("HomeArtScreen", {
            itemId: itemData.item.id,
            from: "home",
          });
        }}
      />
    );
  };

  return (
    <View style={styles.screen}>
      <StatusBar barStyle="light-content" />

      <FlatList
        style={styles.container}
        keyExtractor={(item, index) => item.id}
        data={formatData(popularNfts, numColumns)}
        renderItem={renderGridItem}
        numColumns={numColumns}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  screen: {
    flex: 1,
    backgroundColor: "black",
  },
  container: {
    flex: 1,
    height: "100%",
  },
  header: {
    fontSize: 25,
    color: Colors.primary,
  },
});

export default HomeScreen;
